<template>
  <div class="flex">
    <img id="arrow" :src="getImg()" alt="left-arrow-breadcrumbs" />
    <p
      class="
        uppercase
        font-AvenirFont
        text-lg text-grey-800
        font-bold
        hover:underline
        cursor-pointer
      "
      @click="handleClick"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
import { generateFullPath } from "../utils/fileHelpers";

export default {
  name: "GoBack",
  props: {
    text: String,
    link: String,
    location: String,
  },

  methods: {
    handleClick() {
      this.$router.push({
        name: this.link,
        params: { location: this.location },
      });
    },

    getImg() {
      return generateFullPath("/themes/st2018/img/left-arrow-breadcrumbs.png");
    },
  },
};
</script>

<style scoped>
#arrow {
  width: 13px;
  height: 19px;
  position: relative;
  top: 3px;
  margin-right: 5px;
}
</style>
